import { FunctionComponent, useCallback } from "react";
import { useToast as useChakraToast } from "@chakra-ui/react";
import { Flex, Text, ThemeTypings } from "@/ui";
import CloseIcon from "assets/icons/close.svg?react";
import IconButton from "@/components/IconButton";
import Icon from "@/components/Icon";

type ToastProps = {
  title: string;
  description?: string;
  icon?: FunctionComponent;
  iconFill?: ThemeTypings["colors"];
  customComponent?: React.ReactNode;
};

export default function useToast() {
  const toast = useChakraToast();

  const show = useCallback(
    ({ title, description, icon, iconFill, customComponent }: ToastProps) => {
      const id = toast({
        title,
        description,
        render: () => (
          <Flex
            pos="relative"
            py="0.5rem"
            px="1rem"
            bg="surface2"
            alignItems="center"
            gap="0.75rem"
            borderRadius="1rem"
            mb="1.5rem"
          >
            {icon && <Icon size="20" icon={icon} fill={iconFill} />}
            <Text variant="title" color="on-surface">
              {title}
            </Text>
            {customComponent && customComponent}
            <IconButton p="2" icon={CloseIcon} fill="on-surface" iconSize="24" onClick={() => toast.close(id)} />
          </Flex>
        )
      });
    },
    [toast]
  );

  return { show, closeAll: toast.closeAll };
}
